// extracted by mini-css-extract-plugin
export default {"section":"article-block-module--section--e026f","innerWrapper":"article-block-module--innerWrapper--91fcd"};